import lightingVideo from "../assets/video/lighting_video.mp4";
import { lightingVideoPoster } from "../assets/img/_images";

export const taxRate = 0.0625;
export const shippingCostPerItem = 5;
export const shippingThreshold = 150;
export const unsplashCollectionId = 1118894;
export const navbarHeight = 60;
export const baseImgUrl =
  "https://raw.githubusercontent.com/mattrdiamond/modernist-v2/assets/client/src/assets/img";

export const sortOptions = [
  { value: "Price: Low to High", direction: "asc", sortBy: "price", id: 3 },
  { value: "Price: High to Low", direction: "desc", sortBy: "price", id: 4 },
  { value: "Highest Rated", direction: "desc", sortBy: "rating", id: 0 },
  { value: "Name: A - Z", direction: "asc", sortBy: "name", id: 1 },
  { value: "Name: Z - A", direction: "desc", sortBy: "name", id: 2 },
];

export const HOMEPAGE_VIDEO = {
  videoSrc: lightingVideo,
  posterSrc: lightingVideoPoster,
  title: "Our all-new curtain lineup",
  subtitle: "Available Now",
  ctaText: "Shop Lighting",
  ctaLink: "/shop/lighting",
};
